/* eslint-disable camelcase */
import type { PaymentDetailsConfig } from '../../../api/payment-page-configuration/model';

export interface ZuoraCreditCardDetailsOptions {
  submitEnabled: 'true' | 'false';
  style: 'inline' | 'overlay';
  locale: string;
  id: string;
  signature: string;
  key: string;
  tenantId: string;
  token: string;
  url: string;
  paymentGateway: string;
  field_accountId: number | undefined;
}

export const mapZuoraCreditCardDetailsConfigToOptions = (
  config: PaymentDetailsConfig['options'],
): ZuoraCreditCardDetailsOptions => ({
  submitEnabled: 'true',
  style: 'inline',
  locale: 'en',
  id: config.pageId,
  signature: config.signature,
  key: config.key,
  tenantId: config.tenantId,
  token: config.token,
  url: config.paymentPagesUrl,
  paymentGateway: config.paymentGateway,
  field_accountId: config.externalCustomerId,
});
